import { DateTime } from 'luxon';
import { ENDS_SELECT_OPTIONS, FrequencyType } from 'components/FrequencySelectBlock/FrequencySelectBlock';
import { TriggerTypes } from 'components/TriggerSelectBlock/TriggerSelectBlock';
import { applyTimezoneKeepTimeOfDay } from 'utils/time';

export const validateTaskForm = (
  datum: {
    message?: string;
    generatedMessage?: string | null;
    generatedName?: string | null;
    patient?: string;
    dateTime: Date;
    dateFormat: Date | null;
    timeFormat: Date | null;
    frequency?: FrequencyType;
    trigger?: TriggerTypes;
    expiredDateTime?: Date | null;
  },
  patientTimezone: string
) => {
  let frequencyDateError = '';
  if (datum?.frequency?.ends === ENDS_SELECT_OPTIONS.date) {
    if (datum.frequency.date === null) {
      frequencyDateError = 'End date is required.';
    } else if (datum.frequency.date === undefined) {
      frequencyDateError = 'End date is required.';
    } else if (datum.frequency.date < datum.dateTime) {
      frequencyDateError = 'End date must be after Task start time.';
    }
  }

  return {
    message: datum.message?.trim() ? '' : 'This field is required',
    patient: datum.patient?.trim() ? '' : 'Please select a patient',
    dateTime: !isTimeInThePast(datum.dateTime, patientTimezone)
      ? isTimeDuringSleep(datum.dateTime)
        ? 'Time must be between 5AM and 12AM'
        : ''
      : 'Task time must be in the future',
    frequencyAfter: Number(datum.frequency?.after) > 99 ? 'The max value is 99' : Number(datum.frequency?.after) <= 0 ? 'The min value is 1' : '',
    frequencyDate: frequencyDateError,
    trigger: datum.trigger?.trim() ? '' : 'Please select a trigger',
    expiredDateTime: datum.expiredDateTime ? '' : 'Please select an expiration time',
    dateFormat: datum.dateFormat?.toString() === 'Invalid Date' ? 'Please select a valid date' : '',
    timeFormat: datum.timeFormat?.toString() === 'Invalid Date' ? 'Please select a valid time' : ''
  };
};

export const isTimeInThePast = (date: Date, patientTimezone: string) => {
  const timeNow = DateTime.fromJSDate(new Date(), { zone: patientTimezone }).toJSDate();
  const dateZoned = applyTimezoneKeepTimeOfDay(date, patientTimezone);

  return dateZoned <= timeNow;
};

export const isTimeDuringSleep = (date: Date) => {
  // Get the hours from the dateToCheck
  const hours = date.getHours();

  // Check if the time is between 12 AM and 5 AM
  return hours < 5;
};

export const isValidTaskTime = (date: Date, patientTimezone: string) => {
  if (isTimeInThePast(date, patientTimezone)) return false;
  if (isTimeDuringSleep(date)) return false;

  return true;
};

export const isValidTaskDateRecurrenceEnd = (endDate: Date, scheduledTime: Date) => {
  if (!isValidTaskDate(endDate)) return false;
  const startDateNoTime = new Date(scheduledTime);
  startDateNoTime.setHours(0, 0, 0, 0);
  if (endDate < startDateNoTime) return false;

  return true;
};

export const isValidTaskDate = (date: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date >= today;
};
